import $ from 'jquery';

export function initAdvancedSearch() {

    var $filter = $(".advanced-search-filter");

    var parse_sub_filter = function (sub_filter) {
        var $el = $("." + sub_filter + ".filter");
        $("input[name='" + sub_filter + "']").val("");
        $("input[name='skip']").val("0");
        $el.find("input[type='checkbox']:checked").each(function (idx, chkbx) {
            const value: any = $("input[name='" + sub_filter + "']").val() ?? '';
            var cur = value.length ? value.split(",") : [];
            cur.push($(chkbx).val());
            $("input[name='" + sub_filter + "']").val(cur.join());
        });
    };

    var parse_sub_filter_cluster = function (sub_filter) {
        var $el = $("." + sub_filter + ".filter");
        $("input[name='skip']").val("0");
        $("input[name='" + sub_filter + "']").val("");
        $el.find("input[name='chk_cluster']:checked").each(function (idx, chkbx) {
            const value: any = $("input[name='" + sub_filter + "']").val() ?? '';
            var cur = value.val().length ? value.split(",") : [];
            var $chkbx = $(chkbx);
            var _val = $chkbx.val();
            $filter.find("." + $(chkbx).val() + "-subject input[name='chk_subject']:checked").each(function (idx, subject) {
                _val += "$" + $(subject).val();
            });
            cur.push(_val);
            $("input[name='" + sub_filter + "']").val(cur.join());
        });
    };

    var parse_3_step = function () {

        parse_sub_filter("sector");

        parse_sub_filter("cluster");

        parse_sub_filter("module");

    };

    var btn_handler = {
        "btn_apply_sector": parse_sub_filter,
        "btn_apply_module": parse_sub_filter,
        "btn_apply_cluster": parse_sub_filter_cluster,
        "btn_apply_3_step": parse_3_step
    };

    var set_subject_listener = function () {
        $("input[name='chk_subject']").each(function (idx, el) {

            var $el = $(el);
            $el.off("change");
            $el.on("change", function (e) {

                var $this = $(this);
                var $parent = $this.parents("li:eq(1)");
                var $cluster = $parent.find("input[name='chk_cluster']");

                $cluster.prop("checked", $parent.find("input[name='chk_subject']:checked").length > 0 || $cluster.prop("checked"));

            });
        });
    };


    var set_cluster_listener = function () {
        $("input[name='chk_cluster']").each(function (idx, el) {

            var $el = $(el);

            $el.off("change");
            $el.on("change", function (e) {
                var $this = $(this);
                var $parent = $this.parents("li:eq(0)");
                $parent.find("input[name='chk_subject']:checked").prop("checked", $this.prop("checked"));
                $parent.find("ul").toggleClass("d-none", !$this.prop("checked"));
            });
        });
    };

    var set_prev_next_link = function ($el) {

        $el.on("click", function (e) {
            e.preventDefault();
            var $this = $(this);
            $filter.find("input[name='skip']").val($this.attr("data-skip") ?? '');
            display_results();
        });
    };

    var display_results = function () {
        $(".advanced-search-results").html("");
        $(".advanced-search .loading").removeClass("d-none");
        $.ajax({
            url: zmp_ajax.ajaxurl,
            method: "POST",
            dataType: 'json',
            data: $("form[name='frm-filter']").serialize(),
            success: function (data) {
                $(".advanced-search-results").html(data.rendered_content);
                set_prev_next_link($(".advanced-search-nav-prev"));
                set_prev_next_link($(".advanced-search-nav-next"));
                set_subject_listener();
                set_cluster_listener();
                $(".advanced-search .loading").addClass("d-none");
                $(".advanced-search .zmp-show-result").on("click", function () {
                    $(".advanced-search").toggleClass("mobile-open", false);
                });
            }

        });
    };

    var init_advanced_filter = function () {

        $filter.find(".form-check").each(function (idx, el) {

            var $el = $(el);
            $el.on("click", function (e) {
                var fn = btn_handler["btn_apply_" + $el.attr("data-filter")]($el.attr("data-filter"));
                display_results();
            });

        });

        $filter.find(".reset").each(function (idx, el) {

            var $el = $(el);
            $el.on("click", function (e) {
                var filter = $el.attr("data-filter");
                $filter.find(".filter." + filter + " input[type=checkbox]").prop("checked", false);
                var fn = btn_handler["btn_apply_" + filter](filter);
                display_results();
            });

        });

        display_results();
    };


    if ($filter.length > 0) {

        init_advanced_filter();

    }


    var $3step_filter = $(".advanced-search-filter-3-step");

    var init_3_step_filter = function () {

        $3step_filter.find("select").select2({
            minimumResultsForSearch: -1,
            dropdownAutoWidth: true,
            dropdownParent: $('.advanced-search-filter-3-step form'),
            width: '100%',
            placeholder: "Alle"
        });

        $(".btn-apply").on("click", function (e) {

            e.preventDefault();

            var fn = btn_handler.btn_apply_3_step();

            $("form[name='frm-filter']").submit();

        });

    };


    if ($3step_filter.length > 0) {

        init_3_step_filter();

    }

    $(".advanced-search .zmp-filter").on("click", function () {
        $(".advanced-search").toggleClass("mobile-open");
    });

    $(".advanced-search .zmp-close").on("click", function () {
        $(".advanced-search").toggleClass("mobile-open", false);
    });

}
